import React from 'react'
import styles from './style.module.less'

const OperableArea = ({
  children,
  active,
  imgs,
  onClick,
  id,
  style,
  title,
  quickAction,
  actionRender,
  up,
  down,
  remove,
  edit,
  index
}) => {
  const show = active && id && active === id
  const ActionRender = (actions = []) => {
    const Comp = {
      up: (
        <span key="up">
          <img
            src={
              imgs?.[index - 1]
                ? 'https://qnm.hunliji.com/o_1ckoi6spr17jm1lk33g11r3m1aosj.png'
                : 'https://qnm.hunliji.com/o_1ckoi6spr1s2riapf1s1u081qrk.png'
            }
            onClick={up}
          />
        </span>
      ),
      down: (
        <span key="down">
          <img
            src={
              imgs?.[index + 1]
                ? 'https://qnm.hunliji.com/o_1ckoi6spr2i5nij1497grao8al.png'
                : 'https://qnm.hunliji.com/o_1ckoi6spr18euh82ljkvff1lmkm.png'
            }
            onClick={down}
          />
        </span>
      ),
      edit: (
        <span key="edit">
          <img
            width="20px"
            src="https://qnm.hunliji.com/FnSUApjWf-bH8HYtXuMHYSO8V_7R"
            onClick={edit}
          />
        </span>
      ),
      remove: (
        <span key="remove">
          <img
            src="https://qnm.hunliji.com/o_1ckoi6sprqr3tn01cjp1hpuimvh.png"
            onClick={remove}
          />
        </span>
      )
    }

    const renderItem = actions.map(item => {
      if (Comp[item]) {
        return Comp[item]
      } else {
        return null
      }
    })

    return renderItem
  }

  return (
    <div onClick={e => e.stopPropagation()} className={styles.operableArea}>
      <div
        onClick={() => {
          onClick && onClick(id)
        }}
        className={styles.content}
        style={{
          borderColor: show ? '#448afc' : 'transparent',
          ...style
        }}
      >
        <>{children}</>
      </div>
      {show && (
        <>
          <div className={styles.quickOperation}>
            {ActionRender(quickAction)}
          </div>
          {actionRender && (
            <div className={styles.editOperation}>
              <div className={styles.title}>{title}</div>
              <div className={styles.actionRender}>{actionRender}</div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default OperableArea
